// Integer PCG hash (plan D7) — deterministic, no sin() precision issues, reproducible in JS.
// Shared GLSL prelude fragment; the ShaderAssembler splices this into the assembled material shader.
// NOTE: no backticks and no GLSL-ES-300 reserved identifiers (flat/smooth/etc.) inside the literal.
export const HASH_GLSL = `
// Integer PCG hash (D7) — deterministic across drivers, no sin() precision issues.
uint pcgHash(uint x) {
  uint state = x * 747796405u + 2891336453u;
  uint word = ((state >> ((state >> 28u) + 4u)) ^ state) * 277803737u;
  return (word >> 22u) ^ word;
}

// Hash of a 2D lattice cell, mapped to the unit interval [0, 1).
float hash01(uvec2 v) {
  return float(pcgHash(v.x ^ (v.y * 0x9E3779B1u))) / 4294967296.0;
}

// Three decorrelated hashes of the same cell.
vec3 hash01_3(uvec2 v) {
  return vec3(
    hash01(v),
    hash01(uvec2(v.x + 0x9E3779B1u, v.y + 0x9E3779B1u)),
    hash01(uvec2(v.x + 0x9E3779B1u * 2u, v.y + 0x9E3779B1u * 3u)));
}
`;
